import { render, staticRenderFns } from "./PriceCategories.vue?vue&type=template&id=374aae37&scoped=true&"
import script from "./PriceCategories.vue?vue&type=script&lang=js&"
export * from "./PriceCategories.vue?vue&type=script&lang=js&"
import style0 from "./PriceCategories.vue?vue&type=style&index=0&id=374aae37&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374aae37",
  null
  
)

export default component.exports